import { batchCollectFactory } from 'factories/batch-collect';
import { DashboardCard, DashboardSummary } from 'types';

function populateDashboardCard(
  dashboardCardEntries: any[] = []
): DashboardCard[] {
  return dashboardCardEntries.map((dashboardCard) => {
    const { alert, quantity, type } = dashboardCard;

    return {
      alert: alert ?? false,
      quantity: quantity ?? 0,
      type: type ?? '',
    };
  });
}

export function dashboardSummaryFactory(params: any = {}): DashboardSummary {
  const { entries, lastBatchCollect } = params;

  return {
    entries: populateDashboardCard(entries),
    lastBatchCollect: batchCollectFactory(lastBatchCollect),
  };
}
